import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Toast } from 'angular2-toaster';
import { isBoolean } from 'lodash';
import { ToasterStore } from '../../../toaster/toaster.store';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-message-toast',
  templateUrl: 'message-toast.component.html',
  styleUrls: ['message-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageToastComponent implements OnInit {
  toast: Toast;
  containsHtml: boolean;
  label: string;
  type: string;
  closeIcon: IIcon;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _toasterStore: ToasterStore
  ) {}

  ngOnInit() {
    this.closeIcon = {
      name: 'close',
      size: IconSizesEnum.small,
    };

    this._toasterStore
      .getToasterData()
      .pipe(
        filter((data) =>
          this.toast && data ? data.toastId === this.toast.toastId : false
        ),
        take(1)
      )
      .subscribe((data) => {
        this.label = data.label;
        this.type = data.type || '';

        if (isBoolean(data.containsHtml)) {
          this.containsHtml = data.containsHtml;
        }

        this._changeDetectorRef.markForCheck();
      });
  }
}
